interface LoanWithProgram {
  program?: { name: string } | null;
}

export const distinctProgramNames = (loans: LoanWithProgram[]): string[] => [
  ...new Set(loans.flatMap((loan) => (loan.program ? [loan.program.name] : []))),
];
